import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container-medium">
        <div className="footer-content">
          <div className="footer-column footer-brand">
            <div className="footer-logo">
              <div className="logo-symbol">
                <img src="/images/logo.png" alt="Chattak_logo" height="40" width="40" loading="lazy"
                  onError={e => { e.target.style.display = 'none'; e.target.parentElement.innerText = 'C'; }} />
              </div>
              <div className="logo-text">Chattak</div>
            </div>
            <p className="footer-copyright">
              Copyright © {year} Chattak Ltd.<br />
              All rights reserved.
            </p>
          </div>

          <div className="footer-column">
            <h4>About</h4>
            <ul>
              <li><a href="/#payment-grid">Product</a></li>
              <li><a href="/#use-cases">Use cases</a></li>
              <li><Link to="/company">Company</Link></li>
              <li><a href="/blog">Blog</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Platform</h4>
            <ul>
              <li><a href="https://docs.chattak.com" target="_blank" rel="noreferrer">Developers</a></li>
              <li><Link to="/login" target="_blank" rel="noreferrer">Log in</Link></li>
              <li><a href="https://chattak.statuspage.io/" target="_blank" rel="noreferrer">Status</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy">Privacy policy</Link></li>
              <li><Link to="/terms-of-services">Terms of Use</Link></li>
              <li><a href="/cookie-policy">Cookie Policy</a></li>
              <li><a href="/merchant-terms-and-conditions">Merchant Terms & Conditions</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <h1 className="follow-us">Connect With Us</h1>
          <div className="footer-social">
            <div className="social-icons">
              <a href="https://x.com/ChattakLtd" target="_blank" rel="noreferrer" aria-label="X (Twitter)">
                <img src="/icons/x_icon.svg" alt="Twitter Icon" />
              </a>
              <a href="https://www.linkedin.com/company/chattak/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <img src="/icons/linkedin_icon.svg" alt="LinkedIn Icon" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61576193126647" target="_blank" rel="noreferrer" aria-label="Facebook">
                <img src="/icons/fb_icon.svg" alt="Facebook Icon" />
              </a>
              <a href="https://www.instagram.com/chattak_ltd/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <img src="/icons/insta_icon.svg" alt="Instagram Icon" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}


